import React, { useRef, useEffect, useState, useContext } from "react";

// Componentes PrimeReact
import { Button } from "primereact/button";
import { OverlayPanel } from "primereact/overlaypanel";
import { InputText } from "primereact/inputtext";
import { AuthContext } from "../../../../../../Base/Context/AuthContext/AuthContext";

import AgGrid from "../../../../../../Base/Components/Tables/AgGrid/AgGrid";
import { PODProveedor, GetPODProveedor } from "../../../../../../API/Compras/Ordenes/OrdenesComprasRequests";

const IngresosOverlayPanelDetalle = ({ isMateriaPrima, close, rowData, onChange, selectProveedor, IdProveedor }) => {
  const op = useRef(null);
  const buttom = useRef(null);
  const { userAuth } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [ordenes, setOrdenes] = useState([]);
  const [getOrdenes, setGetOrdenes] = useState([]);

  const obtenerOrdenesCompras = async () => {
    if (selectProveedor) {
      const idProveedor = selectProveedor;
      try {
        const response = await PODProveedor(idProveedor);
        let data
        if(isMateriaPrima){
          data = response?.filter((i) => i?.MateriaPrima === true)
        }else{
          data = response?.filter((i) => i?.MateriaPrima !== true)
        }
        setOrdenes(data);
      } catch (error) {
        console.error("Error al llamar a la API:", error);
        setOrdenes([]);
      }
    } else {
      try {
        const response = await GetPODProveedor(IdProveedor);
        let data
        if(isMateriaPrima){
          data = response?.filter((i) => i?.MateriaPrima === true)
        }else{
          data = response?.filter((i) => i?.MateriaPrima !== true)
        }
        setGetOrdenes(data);
      } catch (error) {
        console.error("Error al llamar a la API:", error);
        setGetOrdenes([]);
      }
    }
  };

  const columns = [
    {
      header: "ID Detalle",
      headerEn: "ID Detail",
      field: "IdPurchaseOrderDetail",
      frozen: true,
      className: "XXsmall",
      hidden: userAuth.IdRol === 1,
    },
    {
      header: "Orden Compra",
      headerEn: "Purchase Order",
      field: "PurchaseOrder",
      frozen: true,
      className: "small",
    },
    {
      header: "Código Producto",
      headerEn: "Product Code",
      field: "CodigoProducto",
      className: "Xsmall",
    },
    {
      header: "Nombre Producto",
      headerEn: "Product Name",
      field: "NombreProducto",
    },
    {
      header: "Desc. Producto",
      headerEn: "Product Desc.",
      field: "DescripcionProducto",
    },
    {
      header: "Proveedor",
      headerEn: "Supplier",
      field: "CustomerName",
      className: "medium",
    },
    {
      header: "Categoría",
      headerEn: "Category Name",
      field: "NombreCategoria",
      className: "Xsmall",
    },
    {
      header: "Sub Categoría",
      headerEn: "Sub Category",
      className: "Xsmall",
      field: "NombreSubcategoria",
    },
    {
      header: "Tipo Producto",
      headerEn: "Product Type Name",
      className: "medium",
      field: "NombreTipoProducto",
    },
    {
      header: "Tipo",
      headerEn: "Type",
      className: "Xsmall",
      field: "Type",
    },
    {
      header: "Cant.",
      headerEn: "Qty.",
      field: "QtyReceive",
      frozen: true,
      alignFrozen: "right",
      className: "Xsmall",
      Format: 'Currency',
      Sumary: 'sum'
    },
    // {
    //   header: "Quantity",
    //   headerEn: "Quantity",
    //   field: "Quantity",
    //   Format: 'Currency',
    //   Sumary: 'sum'
    // },
    {
      header: "Unidad",
      headerEn: "Unit",
      className: "Xsmall",
      headerEn: "Unit Name",
      field: "UnitName",
    },
    {
      header: "Agente",
      headerEn: "Agent's Name",
      field: "UserNameAgente",
    },
    {
      header: "Unit Price",
      headerEn: "Unit Price",
      field: "UnitPrice",
      field: "Quantity",
      className: 'Xsmall',
      Format: 'Currency',
    },
  ];

  const dataToUse = ordenes.length > 0 ? ordenes : getOrdenes;

  const table = {
    Columns: columns,
    Data: dataToUse,
    loading: loading,
    onCellClicked: (e) => onChange(e, rowData),
  };

  useEffect(() => {
    obtenerOrdenesCompras();
  }, []);

  useEffect(() => {
    setLoading(!(ordenes.length > 0 || getOrdenes.length > 0));
    setLoading(false);
  }, [ordenes, getOrdenes]);

  return (
    <div style={{ maxWidth: "50vw" }}>
      <div className="p-inputgroup">
        <InputText
          value={rowData.PurchaseOrder}
          disabled
          placeholder="OrdenCompra"
          onClick={(e) => op.current.toggle(e)}
        />
        <Button
          ref={buttom}
          icon="pi pi-chevron-down"
          style={{ padding: "0.5rem 0.3rem" }}
          type="button"
          onClick={(e) => op.current.toggle(e)}
        />
      </div>

      <OverlayPanel
        ref={op}
        showCloseIcon
        dismissable={false}
        className="OverPanelProductos"
        onHide={close}
      >
        <div style={{ width: 1000, height: 300 }}>
          <AgGrid table={table} />
        </div>
      </OverlayPanel>
    </div>
  );
};

export default IngresosOverlayPanelDetalle;
